import { useEffect } from 'react';

interface UseKeyboardNavigationProps {
  enabled: boolean;
  currentIndex: number;
  maxIndex: number;
  onNavigate: (index: number) => void;
}

export const useKeyboardNavigation = ({
  enabled,
  currentIndex,
  maxIndex,
  onNavigate
}: UseKeyboardNavigationProps) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft' && currentIndex > 0) {
        onNavigate(currentIndex - 1);
      } else if (e.key === 'ArrowRight' && currentIndex < maxIndex) {
        onNavigate(currentIndex + 1);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [enabled, currentIndex, maxIndex, onNavigate]);
};
